import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  CATEGORY_CONSTANTS,
  MenuItemComponentType
} from "../../../../../constants";
import { MenuActionCreators } from "../../../../../redux/action-creators";
import { MenuSelectors } from "../../../../../redux/selectors";
import { useKambiCategoryItems } from "./useKambiCategoryItems";

export const useKambiMenuItemsMobile = trackingInfo => {
  const { sportCategories, visibleCategories, hiddenCategories } =
    useKambiCategoryItems();
  const menuItems = useSelector(MenuSelectors.menuItems);
  const numberOfDisplayedItems = useSelector(
    MenuSelectors.numberOfDisplayedItems
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const handleMenuItemClick = () => {
      dispatch(MenuActionCreators.hideHamburgerMenu());
    };

    const quickLinkItems = getMobileKambiMenuItems(
      visibleCategories,
      trackingInfo,
      handleMenuItemClick
    );

    if (
      sportCategories?.length > CATEGORY_CONSTANTS.NUMBER_OF_ITEMS_MOBILE_LOW
    ) {
      quickLinkItems.push({
        key: "menu-item-show-more-less",
        props: { trackingInfo },
        componentType: MenuItemComponentType.KambiMobileExpandMenuItem
      });
    }

    if (quickLinkItems && quickLinkItems.length) {
      dispatch(MenuActionCreators.setMenuItems(quickLinkItems));
    }
  }, [
    dispatch,
    sportCategories?.length,
    trackingInfo,
    visibleCategories,
    hiddenCategories,
    numberOfDisplayedItems
  ]);

  return menuItems;
};

const getMobileKambiMenuItems = (
  menuCategories,
  trackingInfo,
  handleMenuItemClick
) => {
  let menuItemsList = menuCategories.slice();
  let categories = [];
  for (let item of menuItemsList) {
    const hasChildren = item.items?.length > 0;
    const componentType = hasChildren
      ? MenuItemComponentType.ExpandableSportCategoryMenuItemMobile
      : MenuItemComponentType.SportCategoryMenuItem;

    const menuItem = {
      key: `menu-item-${item.fullURL}-${item.ID || item.sportID}`,
      props: {
        item,
        automationId: item.termKey,
        trackingInfo,
        onClick: (!hasChildren && handleMenuItemClick) || undefined
      },
      componentType
    };

    categories.push(menuItem);
  }
  return categories;
};
